<template>
  <div class="mainContainer">
    <div class="headContainer">
      <span class="headText">编辑学生基础信息</span>
      <div class="right">
        <el-button
            class="btn"
            type="info"
            size="medium"
            icon="el-icon-back"
            @click="$router.go(-1)">
          返回
        </el-button>
        <el-button
            class="btn"
            type="primary"
            size="medium"
            icon="el-icon-check"
            @click="saveData">
          保存
        </el-button>
      </div>
    </div>
    <div class="contentContainer">
      <el-form :model="ywFormData" :rules="rules" ref="ywFormRef" label-width="100px" class="ywForm">
        <el-form-item label="学校名称:" prop="schoolName">
          <el-input v-model="ywFormData.schoolName"></el-input>
        </el-form-item>
        <el-form-item label="地区:" prop="countyname">
          <el-input v-model="ywFormData.countyname"></el-input>
        </el-form-item>
        <el-form-item label="年级:" prop="gradeCode">
          <el-select
              v-model="ywFormData.gradeCode"
              placeholder="请选择年级"
              filterable
          >
            <el-option-group
                v-for="group in gradeInfos"
                :key="group.gradeClass"
                :label="group.gradeClass"
            >
              <el-option
                  v-for="item in group.options"
                  :key="item.gradecode"
                  :label="item.gradename"
                  :value="item.gradecode">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="班级:" prop="className">
          <el-input v-model="ywFormData.className"></el-input>
        </el-form-item>
        <el-form-item label="编号:" prop="serialNo">
          <el-input v-model="ywFormData.serialNo" disabled></el-input>
        </el-form-item>
        <el-form-item label="姓名:" prop="studentName">
          <el-input v-model="ywFormData.studentName"></el-input>
        </el-form-item>
        <el-form-item label="学籍号:" prop="schoolenrnum">
          <el-input v-model="ywFormData.schoolenrnum"></el-input>
        </el-form-item>
        <el-form-item label="性别:" prop="gender">
          <el-radio-group v-model="ywFormData.gender">
            <el-radio label="1">男</el-radio>
            <el-radio label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ManageCheckListInfo.vue",
  data() {
    return {
      serialNo: '',
      ywFormData: {},
      rules: {
        schoolName:[ { required: true, message: "请输入学校名称", trigger: "blur" },],
        countyname:[ { required: true, message: "请输入地区名称", trigger: "blur" },],
        gradeCode:[ { required: true, message: "请选择所属年级", trigger: "change" },],
        className:[ { required: true, message: "请输入班级名称", trigger: "blur" },],
        studentName:[ { required: true, message: "请输入学生姓名", trigger: "blur" },],
      },
      gradeInfos:[]

    }
  },
  mounted() {
    this.serialNo = this.$route.query.serialNo
    this.getStudentInfo(this.serialNo)
    this.initGradeInfo()
  },
  methods: {
    initGradeInfo() {
      this.getRequest("/student/getGradeInfo").then(({data}) => {
        this.gradeInfos = data
      }).catch(e => console.log("加载年级信息失败！",e.message))
    },
    saveData() {
      this.$refs['ywFormRef'].validate(valid => {
        if (valid) {
          this.postRequest("/student/saveOrUpdateInfo", this.ywFormData)
              .then(resp => {
                if (resp && resp.status) {
                  this.$message.success("修改成功！")
                  this.$router.go(-1)
                }
              })
        }
      });

    },
    getStudentInfo(serialNo) {
      console.log("查询学生基础信息：", serialNo)
      let params = {
        serialNo: serialNo
      }
      this.getRequest("/employee/basic/getStudentBasicInfoBySerialNo",
          {params: params}
      )
          .then(({data}) => {
            this.ywFormData = data
          })
    }
  }
}
</script>

<style scoped>
.mainContainer {
  height: calc(100vh - 126px);
  background: rgba(246, 245, 245, 0.62);
  padding: 4px;
}

.headContainer {
  height: 40px;
  border: 1px solid #cbcbcd;
  border-radius: 4px;
  margin-bottom: 8px;
  background: linear-gradient(90deg, #4278b8 30%, #4d7fb3 60%, #b1c8ee 80%);
  align-items: center; /* 垂直居中 */
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.headText {
  font-family: 宋体;
  font-size: 18px;
  font-weight: bold;
  line-height: 36px;
  margin-left: 10px;
  color: #fff;
}

.headContainer .right {
  display: flex; /* 使按钮水平排列 */
  justify-content: flex-end; /* 使按钮居右 */
  margin-right: 10px;
}

.headText {
  font-family: 宋体;
  font-size: 18px;
  font-weight: bold;
  line-height: 36px;
  margin-left: 10px;
  color: #fff;
}

.contentContainer {
  height: calc(100% - 68px);
  border: 1px solid #b8b7b7;
  border-radius: 4px;
  padding: 8px;
  box-shadow: 0px 2px 2px #9c9b9b;
}

</style>